<template>
    <section class="globalSiteWeflix" v-if="finalWebsite">
        <Header @toggleModal="toggleOpenDialog" @toggleModalSubscribe="toggleOpenSubscribe" />
        
        <!-- Hero Section com Destaque para Teste Grátis -->
        <section class="hero-section">
            <div class="hero-content">
                <h1>Filmes, séries e muito mais, sem limites</h1>
                <h2>Assista onde quiser. Cancele quando quiser.</h2>
                
                <div class="trial-highlight">
                    <p class="trial-text">Experimente grátis por {{ trialWeflix.trialDays }} dias</p>
                    <button class="btn-trial" @click="goToCheckout(plansWeflixLocal.find(plan => plan.planValue === 0))">
                        Comece seu teste grátis
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <p class="trial-note">
                        Após o período de teste, apenas R$ 
                        {{ 
                            plansWeflixLocal.length > 0 
                            ? formatarNumero(plansWeflixLocal.filter(plan => plan.planValue > 0).reduce((min, plan) => plan.planValue < min ? plan.planValue : min, plansWeflixLocal[0].planValue)) 
                            : '0,00' 
                        }}/mês. Cancele quando quiser.
                    </p>
                </div>
            </div>
        </section>

        <!-- Seção de Planos -->
        <section class="plans-section" v-if="plansWeflix.length > 0">
            <div class="container">
                <h2 class="section-title">Escolha seu plano</h2>
                <p class="section-subtitle">Todos os planos incluem o período de teste gratuito de {{ trialWeflix.trialDays }} dias.</p>
                
                <div class="plans-grid">
                    <div class="plan-card" v-for="plan in plansWeflixLocal.filter(plan => plan.planValue > 0)" :key="plan.id" :class="{ 'highlighted': plan.recommended }" @click="goToCheckout(plan)">
                        <div class="plan-header">
                            <h3>{{ plan.name }}</h3>
                            <span class="recommended-badge" v-if="plan.recommended">Recomendado</span>
                        </div>
                        
                        <div class="plan-price">
                            <span class="price-amount">R$ {{ formatarNumero(plan.planValue) }}</span>
                            <span class="price-period">/mês</span>
                        </div>
                        
                        <ul class="plan-features">
                            <li v-for="(feature, index) in plan.features" :key="index">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="#00C853" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                {{ feature }}
                            </li>
                        </ul>
                        
                        <button class="btn-plan" @click="goToCheckout(plan)">
                            {{ plan.planValue === 0 ? 'Experimente grátis' : 'Assinar agora' }}
                        </button>
                    </div>
                </div>
            </div>
        </section>

      
        <Footer v-if="finalWebsite" />
        <Login :show="openDialogLogin" @toggleModal="toggleOpenDialog" />
        <Subscribe :show="openDialogSubscribe" @toggleModal="toggleOpenSubscribe" />
    </section>
</template>

<script>
import Header from "@/components/Weflix/Hedaer.vue"
import Banner from "@/components/Weflix/Banner.vue"
import Footer from '@/components/Weflix/Footer.vue'
import Login from '@/components/Weflix/Login.vue'
import Subscribe from '@/components/Weflix/Subscribe.vue'
import { mapState, mapActions } from 'vuex';
import ApiPlans from '@/utils/Weflix/Website/plans'

export default {
    data() {
        return {
            openDialogLogin: false,
            openDialogSubscribe: false,
            plansWeflixLocal: [],
        }
    },
    components: {
        Header,
        Banner,
        Footer,
        Login,
        Subscribe,
    },
    computed: {
        ...mapState(['finalWebsite', 'plansWeflix', 'trialWeflix']),
    },
    methods: {
        ...mapActions(['storeFinalWebsite', 'storePlansWeflix', 'storeItemCheckoutWeflix']),
        async fetchPlans() {
            const baseUrl = window.location.origin;
            if(baseUrl.includes('localhost:')){
                this.baseUrl = 'https://homolog.weflix.com.br';
            } else {
                this.baseUrl = baseUrl;
            }
            const aux = this.baseUrl.replace(/\/$/, '');

            const payload = {
                "url": aux
            }
            try {
                const response = await ApiPlans.getPlans(payload);
                this.plansWeflixLocal = response.map(plan => ({
                    ...plan,
                    description: plan.description || 'Acesso completo a todo o catálogo',
                    features: plan.features || [
                        'Acesso ilimitado',
                        'Qualidade HD',
                        'Assista em qualquer dispositivo',
                        'Cancelamento a qualquer momento'
                    ],
                    recommended: plan.recommended || false
                }));
                this.storeHasSinglePurchase({
                    hasSinglePurchase: response.length > 0 ? false : true
                });
            } catch (error) {
                console.error(error);
            }
        },
        formatarNumero(numero) {
            let number = parseFloat(numero).toFixed(2);
            return number.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        },
        goToCheckout(plan){
            const planSubscribe = {
                "name":plan.name,
                "price":plan.planValue,
                "type":plan.type,
                "id":plan.id
            }
            document.body.style.overflow = '';
            this.storeItemCheckoutWeflix({itemCheckoutWeflix:planSubscribe});
            this.$router.push('/checkoutweflix');
        
        },
        toggleOpenDialog() {
            this.openDialogLogin = !this.openDialogLogin;
        },
        toggleOpenSubscribe() {
            if (this.finalWebsite.company.cartStatus && this.finalWebsite.company.cartStatus === 1) {
                this.openDialogSubscribe = !this.openDialogSubscribe;
            }
        },
        subscribeTrial() {
            const trialPlan = this.plansWeflixLocal.find(plan => plan.planValue === 0);
            const planSubscribe = {
                "name":trialPlan.name,
                "price":trialPlan.planValue,
                "type":trialPlan.type,
                "id":trialPlan.id
            }
            document.body.style.overflow = '';
            this.storeItemCheckoutWeflix({itemCheckoutWeflix:planSubscribe});
            this.$router.push('/checkoutweflix');
        }
    },
    mounted() {
        if(this.plansWeflix.length === 0){
            this.fetchPlans();
        } else {
            this.plansWeflixLocal = this.plansWeflix;
        }
    }
};
</script>

<style scoped>
.globalSiteWeflix {
    background-color: #0F0F0F;
    color: #FFFFFF;
    font-family: 'Netflix Sans', 'Helvetica Neue', Arial, sans-serif;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

/* Hero Section */
.hero-section {
    background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), 
                url('https://homolog.weflix.com.br/assets/images/hero-bg.jpg') no-repeat center center;
    background-size: cover;
    height: 80vh;
    min-height: 500px;
    display: flex;
    align-items: center;
    text-align: center;
    padding: 0 20px;
}

.hero-content {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}

.hero-content h1 {
    font-size: 3.5rem;
    font-weight: 800;
    margin-bottom: 1rem;
    line-height: 1.1;
}

.hero-content h2 {
    font-size: 1.8rem;
    font-weight: 400;
    margin-bottom: 2rem;
}

/* Trial Highlight */
.trial-highlight {
    margin-top: 2rem;
}

.trial-text {
    font-size: 1.2rem;
    margin-bottom: 1rem;
}

.btn-trial {
    background-color: #E50914;
    color: white;
    border: none;
    padding: 15px 30px;
    font-size: 1.5rem;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    transition: background-color 0.2s;
}

.btn-trial:hover {
    background-color: #F40612;
}

.trial-note {
    margin-top: 1rem;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.8);
}

/* Plans Section */
.plans-section {
    background-color: #0F0F0F;
}

.section-title {
    font-size: 2.5rem;
    text-align: center;
    margin-bottom: 1rem;
}

.section-subtitle {
    font-size: 1.2rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 3rem;
}

.plans-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    margin-top: 40px;
}

.plan-card {
    background-color: #1F1F1F;
    border-radius: 8px;
    padding: 30px;
    transition: transform 0.3s, box-shadow 0.3s;
    position: relative;
    overflow: hidden;
}

.plan-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}

.plan-card.highlighted {
    border: 2px solid #E50914;
}

.plan-header {
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.plan-header h3 {
    font-size: 1.8rem;
    font-weight: 600;
    margin: 0;
}

.recommended-badge {
    background-color: #E50914;
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 600;
    margin-top: 28px !important;
    display: block;
    width: 50%;
    margin: 0 auto;
}

.plan-description {
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 25px;
    min-height: 60px;
}

.plan-price {
    margin-bottom: 25px;
}

.price-amount {
    font-size: 2.5rem;
    font-weight: 700;
}

.price-period {
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.7);
}

.plan-features {
    list-style: none;
    padding: 0;
    margin-bottom: 30px;
}

.plan-features li {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
    font-size: 1rem;
}

.btn-plan {
    width: 100%;
    background-color: #E50914;
    color: white;
    border: none;
    padding: 12px;
    font-size: 1.1rem;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-plan:hover {
    background-color: #F40612;
}

/* FAQ Section */
.faq-section {
    padding: 80px 0;
    background-color: #000;
}

.faq-item {
    max-width: 800px;
    margin: 0 auto 10px;
    border-bottom: 1px solid #333;
}

.faq-question {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    cursor: pointer;
}

.faq-question h3 {
    font-size: 1.3rem;
    font-weight: 500;
    margin: 0;
}

.faq-question svg {
    transition: transform 0.3s;
}

.faq-question:hover h3 {
    color: #E50914;
}

.faq-answer {
    padding-bottom: 20px;
    color: rgba(255, 255, 255, 0.8);
    display: none;
}

.faq-answer.active {
    display: block;
}

/* Responsividade */
@media (max-width: 768px) {
    .hero-content h1 {
        font-size: 2.5rem;
    }
    
    .hero-content h2 {
        font-size: 1.3rem;
    }
    
    .btn-trial {
        font-size: 1.2rem;
        padding: 12px 24px;
    }
    
    .plans-grid {
        grid-template-columns: 1fr;
    }
}
section.plans-section .container {
    background-color: black;
    max-width: 1500px !important;
    margin: 0 auto !important;
}
</style>